import { Input, InputProps } from "@chakra-ui/react";

interface DateFilterProps extends Omit<InputProps, "type" | "value" | "onChange"> {
  value: string;
  onChange: (value: string) => void;
}

export default function DateFilter({ value, onChange, ...rest }: DateFilterProps) {
  return (
    <Input
      type="date"
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      height="36px"
      fontSize="14px"
      borderColor="gray.300"
      borderWidth="1px"
      borderStyle="solid"
      borderRadius="md"
      paddingX="8px"
      _hover={{
        borderColor: "gray.400",
        bg: "gray.50",
      }}
      _focus={{
        borderColor: "cdsIndigo.400",
        boxShadow: "none",
      }}
      sx={{
        "&::-webkit-calendar-picker-indicator": {
          cursor: "pointer",
        },
      }}
      {...rest}
    />
  );
}
